import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ParentDetails } from '../model/parent.type';

export const getParentById = async (parentId: string) => {
  const response = await baseAPI.get<ParentDetails>(`/parents/${parentId}`);
  return response.data;
};

export const useGetParentById = (parentId: string) => {
  return useQuery({
    queryKey: [KEYS.PARENT, parentId],
    queryFn: () => getParentById(parentId),
    placeholderData: keepPreviousData,
    enabled: !!parentId,
  });
};
